import React from 'react';

const Icon = ({ size = '32', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none" {...other}>
            <path
                d="M12.515 4.572H6.631a2.061 2.061 0 0 0-2.06 2.06v5.884a2.06 2.06 0 0 0 2.06 2.061h5.884a2.06 2.06 0 0 0 2.061-2.06V6.632a2.061 2.061 0 0 0-2.061-2.061Zm0 12.848H6.631a2.061 2.061 0 0 0-2.06 2.06v5.884a2.06 2.06 0 0 0 2.06 2.061h5.884a2.061 2.061 0 0 0 2.061-2.06V19.48a2.06 2.06 0 0 0-2.061-2.061ZM25.32 4.572h-5.884a2.061 2.061 0 0 0-2.061 2.06v5.884a2.06 2.06 0 0 0 2.061 2.061h5.884a2.06 2.06 0 0 0 2.06-2.06V6.632a2.061 2.061 0 0 0-2.06-2.061Zm.05 12.848h-5.883a2.06 2.06 0 0 0-2.061 2.06v5.884a2.06 2.06 0 0 0 2.06 2.061h5.884a2.061 2.061 0 0 0 2.061-2.06V19.48a2.06 2.06 0 0 0-2.06-2.061Z"
                stroke="#3F68E0"
                strokeWidth="1.829"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="m7.758 9.52 1.249 1.248 2.378-2.379"
                stroke="#3F68E0"
                strokeWidth="1.829"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
